import { render } from "./UserIcon.vue?vue&type=template&id=03b40554"
import script from "./UserIcon.vue?vue&type=script&lang=js"
export * from "./UserIcon.vue?vue&type=script&lang=js"
script.render = render

export default script